import type { RegistrySource } from './DataSourcesDirectory.types';

export const REGISTRY_SOURCES: RegistrySource[] = [
  {
    country: 'Afghanistan',
    region: 'Asia',
    flag: '🇦🇫',
    source1: 'Afghanistan Central Business Registry (ACBR)',
    source2: 'ARD (Afghanistan Revenue Department)',
    frequency: 'monthly',
  },
  {
    country: 'Åland Islands',
    region: 'Europe',
    flag: '🇦🇽',
    source1: 'Finnish Trade Register (maintained by the Finnish Patent and Registration Office, PRH)',
    source2: 'Finnish Tax Administration (Verohallinto)',
    frequency: 'daily',
  },
  {
    country: 'Albania',
    region: 'Europe',
    flag: '🇦🇱',
    source1: 'National Business Center (QKB)',
    source2: 'General Directorate of Taxation (Drejtoria e Përgjithshme e Tatimeve)',
    frequency: 'daily',
  },
  {
    country: 'Algeria',
    region: 'Africa',
    flag: '🇩🇿',
    source1: 'National Centre of the Trade Register (Centre National du Registre du Commerce, CNRC)',
    source2: "Numéro d'Identification Fiscale (NIF)",
    frequency: 'monthly',
  },
  {
    country: 'American Samoa',
    region: 'Oceania',
    flag: '🇦🇸',
    source1: 'Department of Commerce, American Samoa Government (Business Registration Division)',
    source2: 'American Samoa Department of Treasury – Tax Division',
    frequency: 'monthly',
  },
  {
    country: 'Angola',
    region: 'Africa',
    flag: '🇦🇴',
    source1: 'Instituto de Registos e Notariado (Institute of Registries and Notary)',
    source2: 'Administração Geral Tributária (AGT)',
    frequency: 'monthly',
  },
  {
    country: 'Antigua & Barbuda',
    region: 'Americas',
    flag: '🇦🇬',
    source1: 'Corporate Affairs and Intellectual Property Office (CAIPO)',
    source2: 'Antigua & Barbuda Inland Revenue Department (IRD)',
    frequency: 'monthly',
  },
  {
    country: 'Argentina',
    region: 'Americas',
    flag: '🇦🇷',
    source1: 'Inspección General de Justicia (IGJ)',
    source2: 'Administración Federal de Ingresos Públicos (AFIP)',
    frequency: 'daily',
  },
  {
    country: 'Armenia',
    region: 'Europe',
    flag: '🇦🇲',
    source1: 'State Register of Legal Entities',
    source2: 'State Revenue Committee of the Republic of Armenia',
    frequency: 'monthly',
  },
  {
    country: 'Aruba',
    region: 'Americas',
    flag: '🇦🇼',
    source1: 'Aruba Chamber of Commerce and Industry (KvK Aruba',
    source2: 'Belastingdienst Aruba (Aruba Tax Department)',
    frequency: 'monthly',
  },
  {
    country: 'Australia',
    region: 'Oceania',
    flag: '🇦🇺',
    source1: 'Australian Securities and Investments Commission (ASIC)',
    source2: 'Australian Business Register (ABR)',
    frequency: 'weekly',
  },
  {
    country: 'Austria',
    region: 'Europe',
    flag: '🇦🇹',
    source1: 'Austrian Business Register (Firmenbuch)',
    source2: 'Austrian Federal Ministry of Finance (Bundesministerium für Finanzen)',
    frequency: 'daily',
  },
  {
    country: 'Azerbaijan',
    region: 'Asia',
    flag: '🇦🇿',
    source1: 'State Registry of Legal Entities (under the Ministry of Taxes)',
    source2: 'Ministry of Taxes of the Republic of Azerbaijan',
    frequency: 'monthly',
  },
  {
    country: 'Bahamas',
    region: 'Americas',
    flag: '🇧🇸',
    source1: "Registrar General's Department",
    source2: 'Bahamas Department of Inland Revenue',
    frequency: 'monthly',
  },
  {
    country: 'Bahrain',
    region: 'Middle East',
    flag: '🇧🇭',
    source1: 'Ministry of Industry, Commerce and Tourism (Commercial Registration Directorate)',
    source2: 'National Bureau for Revenue (NBR)',
    frequency: 'weekly',
  },
  {
    country: 'Bangladesh',
    region: 'Asia',
    flag: '🇧🇩',
    source1: 'Registrar of Joint Stock Companies and Firms (RJSC)',
    source2: 'National Board of Revenue (NBR)',
    frequency: 'weekly',
  },
  {
    country: 'Barbados',
    region: 'Americas',
    flag: '🇧🇧',
    source1: 'Corporate Affairs and Intellectual Property Office (CAIPO)',
    source2: 'Barbados Revenue Authority (BRA)',
    frequency: 'monthly',
  },
  {
    country: 'Belarus',
    region: 'Europe',
    flag: '🇧🇾',
    source1:
      'Unified State Register of Legal Entities and Individual Entrepreneurs (managed by the Ministry of Justice)',
    source2: 'Ministry of Taxes and Duties of the Republic of Belarus',
    frequency: 'daily',
  },
  {
    country: 'Belgium',
    region: 'Europe',
    flag: '🇧🇪',
    source1: 'Crossroads Bank for Enterprises (Banque-Carrefour des Entreprises / Kruispuntbank van Ondernemingen)',
    source2: 'Federal Public Service Finance (Service Public Fédéral Finances / Federale Overheidsdienst Financiën)',
    frequency: 'daily',
  },
  {
    country: 'Belize',
    region: 'Americas',
    flag: '🇧🇿',
    source1: 'Belize Companies and Corporate Affairs Registry (CACAR)',
    source2: 'Belize Tax Service',
    frequency: 'monthly',
  },
  {
    country: 'Benin',
    region: 'Africa',
    flag: '🇧🇯',
    source1: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
    source2: 'Direction Générale des Impôts et des Domaines (DGID)',
    frequency: 'monthly',
  },
  {
    country: 'Bermuda',
    region: 'Americas',
    flag: '🇧🇲',
    source1: 'Bermuda Monetary Authority (BMA)',
    source2: "Bermuda Government – Tax Commissioner's Office",
    frequency: 'monthly',
  },
  {
    country: 'Bolivia',
    region: 'Americas',
    flag: '🇧🇴',
    source1: 'Servicio de Registro de Comercio (SERECI)',
    source2: 'Servicio de Impuestos Nacionales (SIN)',
    frequency: 'monthly',
  },
  {
    country: 'Bonaire',
    region: 'Americas',
    flag: '🇧🇶',
    source1: 'Chamber of Commerce of Curaçao',
    source2: 'Belastingdienst Caribisch Nederland (Caribbean Netherlands Tax Office)',
    frequency: 'monthly',
  },
  {
    country: 'Bosnia & Herzegovina',
    region: 'Europe',
    flag: '🇧🇦',
    source1: 'Register of Business Entities',
    source2: 'Indirect Taxation Authority of Bosnia and Herzegovina',
    frequency: 'daily',
  },
  {
    country: 'Botswana',
    region: 'Africa',
    flag: '🇧🇼',
    source1: 'Companies and Intellectual Property Authority (CIPA)',
    source2: 'Botswana Unified Revenue Service (BURS)',
    frequency: 'monthly',
  },
  {
    country: 'Brazil',
    region: 'Americas',
    flag: '🇧🇷',
    source1: 'Junta Comercial (Commercial Registry)',
    source2: 'Receita Federal do Brasil (RFB)',
    frequency: 'daily',
  },
  {
    country: 'Bulgaria',
    region: 'Europe',
    flag: '🇧🇬',
    source1: 'Bulgarian Commercial Register',
    source2: 'National Revenue Agency (NRA)',
    frequency: 'daily',
  },
  {
    country: 'Burkina Faso',
    region: 'Africa',
    flag: '🇧🇫',
    source1: 'Registre du Commerce et du Crédit Mobilier (RCCM',
    source2: 'Ministry of Finance, Burkina Faso',
    frequency: 'monthly',
  },
  {
    country: 'Burundi',
    region: 'Africa',
    flag: '🇧🇮',
    source1: 'Trade and Personal Property Credit Register',
    source2: 'Office Burundais des Recettes (OBR)',
    frequency: 'monthly',
  },
  {
    country: 'Cambodia',
    region: 'Asia',
    flag: '🇰🇭',
    source1: 'Ministry of Commerce (Department of Business Registration)',
    source2: 'General Department of Taxation (GDT), Ministry of Economy and Finance, Cambodia',
    frequency: 'weekly',
  },
  {
    country: 'Cameroon',
    region: 'Africa',
    flag: '🇨🇲',
    source1: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
    source2: 'Direction Générale des Impôts (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Cape Verde',
    region: 'Africa',
    flag: '🇨🇻',
    source1: 'Conservatória do Registo Comercial (Commercial Registry Office)',
    source2: 'Direção Nacional de Receitas do Estado (DNRE)',
    frequency: 'monthly',
  },
  {
    country: 'Cayman Islands',
    region: 'Americas',
    flag: '🇰🇾',
    source1: 'Cayman Islands General Registry (Companies Registry)',
    source2: 'Cayman Islands Tax Information Authority.',
    frequency: 'monthly',
  },
  {
    country: 'Central African Rep',
    region: 'Africa',
    flag: '🇨🇫',
    source1: 'Registre de Commerce et du Crédit Mobilier (RCCM)',
    source2: 'Tax Directorate (Direction Générale des Impôts)',
    frequency: 'monthly',
  },
  {
    country: 'Chad',
    region: 'Africa',
    flag: '🇹🇩',
    source1: 'Registre de Commerce et du Crédit Mobilier (RCCM)',
    source2: 'General Directorate of Taxes and Domains (Direction Générale des Impôts et des Domaines)',
    frequency: 'monthly',
  },
  {
    country: 'Chile',
    region: 'Americas',
    flag: '🇨🇱',
    source1: 'Registro de Empresas y Sociedades (RES)',
    source2: 'Internal Revenue Service (Servicio de Impuestos Internos, SII)',
    frequency: 'daily',
  },
  {
    country: 'China',
    region: 'Asia',
    flag: '🇨🇳',
    source1: 'State Administration for Market Regulation (SAMR)',
    source2: "State Taxation Administration (STA) of the People's Republic of China",
    frequency: 'daily',
  },
  {
    country: 'Colombia',
    region: 'Americas',
    flag: '🇨🇴',
    source1: 'Cámara de Comercio (Chambers of Commerce)',
    source2: 'National Tax and Customs Directorate (Dirección de Impuestos y Aduanas Nacionales, DIAN)',
    frequency: 'daily',
  },
  {
    country: 'Congo',
    region: 'Africa',
    flag: '🇨🇬',
    source1: 'Registre de Commerce et du Crédit Mobilier (RCCM)',
    source2: 'General Directorate of Taxes (Direction Générale des Impôts)',
    frequency: 'monthly',
  },
  {
    country: 'Congo (DRC)',
    region: 'Africa',
    flag: '🇨🇩',
    source1: "Guichet Unique de Création d'Entreprise (GUCE)",
    source2: 'General Directorate of Administrative, Judicial, Domain and Participation Revenues (DGRAD)',
    frequency: 'monthly',
  },
  {
    country: 'Croatia',
    region: 'Europe',
    flag: '🇭🇷',
    source1: 'Court Register (Sudski registar)',
    source2: 'Croatian Tax Administration (Porezna uprava)',
    frequency: 'daily',
  },
  {
    country: 'Curaçao',
    region: 'Americas',
    flag: '🇨🇼',
    source1: 'Chamber of Commerce of Curaçao',
    source2: 'Belastingdienst Curaçao (Curaçao Tax Department)',
    frequency: 'monthly',
  },
  {
    country: 'Cyprus',
    region: 'Europe',
    flag: '🇨🇾',
    source1: 'Department of Registrar of Companies and Official Receiver',
    source2: 'Tax Department of the Ministry of Finance',
    frequency: 'daily',
  },
  {
    country: 'Czechia (Czech Rep)',
    region: 'Europe',
    flag: '🇨🇿',
    source1: 'Commercial Register (Obchodní rejstřík)',
    source2: 'Financial Administration of the Czech Republic (Finanční správa České republiky)',
    frequency: 'daily',
  },
  {
    country: 'Denmark',
    region: 'Europe',
    flag: '🇩🇰',
    source1: 'Danish Business Authority (Erhvervsstyrelsen) — Central Business Register (CVR)',
    source2: 'Danish Tax Agency (Skattestyrelsen)',
    frequency: 'daily',
  },
  {
    country: 'Djibouti',
    region: 'Africa',
    flag: '🇩🇯',
    source1: 'Registre de Commerce et du Crédit Mobilier (RCCM)',
    source2: 'Directorate General of Taxes and Domain (Direction Générale des Impôts et des Domaines)',
    frequency: 'monthly',
  },
  {
    country: 'Dominica',
    region: 'Americas',
    flag: '🇩🇲',
    source1: 'Corporate Affairs and Intellectual Property Office (CAIPO)',
    source2: 'Inland Revenue Division, Ministry of Finance, Dominica',
    frequency: 'monthly',
  },
  {
    country: 'Dominican Rep',
    region: 'Americas',
    flag: '🇩🇴',
    source1:
      'National Office of Industrial Property and Mercantile Registry (Oficina Nacional de la Propiedad Industrial y Registro Mercantil)',
    source2: 'Dirección General de Impuestos Internos (DGII)',
    frequency: 'monthly',
  },
  {
    country: 'Ecuador',
    region: 'Americas',
    flag: '🇪🇨',
    source1: 'Superintendency of Companies, Securities and Insurance',
    source2: 'Internal Revenue Service (Servicio de Rentas Internas, SRI)',
    frequency: 'daily',
  },
  {
    country: 'Egypt',
    region: 'Africa',
    flag: '🇪🇬',
    source1: 'General Authority for Investment and Free Zones (GAFI)',
    source2: 'Egyptian Tax Authority (ETA)',
    frequency: 'weekly',
  },
  {
    country: 'El Salvador',
    region: 'Americas',
    flag: '🇸🇻',
    source1: 'National Registry Center',
    source2: 'General Directorate of Internal Taxes- Dirección General de Impuestos Internos (DGII)',
    frequency: 'monthly',
  },
  {
    country: 'Equatorial Guinea',
    region: 'Africa',
    flag: '🇬🇶',
    source1: 'Registro Mercantil',
    source2: 'General Tax Directorate (Dirección General de Impuestos)',
    frequency: 'monthly',
  },
  {
    country: 'Eritrea',
    region: 'Africa',
    flag: '🇪🇷',
    source1: 'Ministry of Trade and Industry',
    source2: 'Ministry of Finance and National Development Planning',
    frequency: 'monthly',
  },
  {
    country: 'Estonia',
    region: 'Europe',
    flag: '🇪🇪',
    source1: 'Estonian Business Register',
    source2: 'Estonian Tax and Customs Board (Maksu- ja Tolliamet)',
    frequency: 'daily',
  },
  {
    country: 'Ethiopia',
    region: 'Africa',
    flag: '🇪🇹',
    source1: 'Ministry of Trade and Industry (Business Registration Directorate)',
    source2: 'Ethiopian Revenues and Customs Authority (ERCA)',
    frequency: 'monthly',
  },
  {
    country: 'Fiji',
    region: 'Oceania',
    flag: '🇫🇯',
    source1: 'Fiji Registrar of Companies',
    source2: 'Fiji Revenue and Customs Service (FRCS)',
    frequency: 'monthly',
  },
  {
    country: 'Finland',
    region: 'Europe',
    flag: '🇫🇮',
    source1: 'PRH',
    source2: 'Finnish Tax Administration (Verohallinto)',
    frequency: 'daily',
  },
  {
    country: 'France',
    region: 'Europe',
    flag: '🇫🇷',
    source1: 'INPI',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'daily',
  },
  {
    country: 'French Guiana',
    region: 'Americas',
    flag: '🇬🇫',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'Gabon',
    region: 'Africa',
    flag: '🇬🇦',
    source1: 'Registre de Commerce et du Crédit Mobilier (RCCM)',
    source2: 'General Directorate of Taxes (Direction Générale des Impôts)',
    frequency: 'monthly',
  },
  {
    country: 'Gambia',
    region: 'Africa',
    flag: '🇬🇲',
    source1: "Registrar General's Department",
    source2: 'Gambia Revenue Authority (GRA)',
    frequency: 'monthly',
  },
  {
    country: 'Georgia',
    region: 'Europe',
    flag: '🇬🇪',
    source1: 'National Agency of Public Registry (NAPR)',
    source2: 'Revenue Service of Georgia',
    frequency: 'daily',
  },
  {
    country: 'Germany',
    region: 'Europe',
    flag: '🇩🇪',
    source1: 'Handelsregister (Commercial Register)',
    source2: 'Federal Central Tax Office (Bundeszentralamt für Steuern)',
    frequency: 'realtime',
  },
  {
    country: 'Ghana',
    region: 'Africa',
    flag: '🇬🇭',
    source1: "Registrar General's Department",
    source2: 'Ghana Revenue Authority (GRA)',
    frequency: 'monthly',
  },
  {
    country: 'Greece',
    region: 'Europe',
    flag: '🇬🇷',
    source1: 'General Commercial Registry (GEMI)',
    source2: 'Independent Authority for Public Revenue (AADE)',
    frequency: 'daily',
  },
  {
    country: 'Greenland',
    region: 'Americas',
    flag: '🇬🇱',
    source1: 'Business Register Greenland',
    source2: 'Greenland Tax Agency (Skattestyrelsen Grønland)',
    frequency: 'monthly',
  },
  {
    country: 'Grenada',
    region: 'Americas',
    flag: '🇬🇩',
    source1: 'Corporate Affairs and Intellectual Property Office (CAIPO)',
    source2: 'Inland Revenue Division, Ministry of Finance, Grenada',
    frequency: 'monthly',
  },
  {
    country: 'Guadeloupe',
    region: 'Americas',
    flag: '🇬🇵',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'Guam',
    region: 'Oceania',
    flag: '🇬🇺',
    source1: 'Department of Revenue and Taxation',
    source2: 'Guam Department of Revenue and Taxation',
    frequency: 'monthly',
  },
  {
    country: 'Guatemala',
    region: 'Americas',
    flag: '🇬🇹',
    source1: 'Mercantile Registry (Registro Mercantil)',
    source2: 'Superintendencia de Administración Tributaria (SAT)',
    frequency: 'monthly',
  },
  {
    country: 'Guinea',
    region: 'Africa',
    flag: '🇬🇳',
    source1: '(RCCM)',
    source2: 'Direction Nationale des Impôts (DNI)',
    frequency: 'monthly',
  },
  {
    country: 'Guinea-Bissau',
    region: 'Africa',
    flag: '🇬🇼',
    source1: 'Commercial Registry',
    source2: 'Autoridade Tributária da Guiné-Bissau (ATGB)',
    frequency: 'monthly',
  },
  {
    country: 'Guyana',
    region: 'Americas',
    flag: '🇬🇾',
    source1: 'Deeds Registry (Business Registration Unit)',
    source2: 'Guyana Revenue Authority (GRA)',
    frequency: 'monthly',
  },
  {
    country: 'Haiti',
    region: 'Americas',
    flag: '🇭🇹',
    source1: 'Trade and Personal Property Credit Register',
    source2: 'General Directorate of Taxes (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Honduras',
    region: 'Americas',
    flag: '🇭🇳',
    source1: 'Mercantile Registry (Registro Mercantil)',
    source2: 'Tax Administration Service (SAR)',
    frequency: 'monthly',
  },
  {
    country: 'Hong Kong',
    region: 'Asia',
    flag: '🇭🇰',
    source1: 'Companies Registry',
    source2: 'Inland Revenue Department (IRD)',
    frequency: 'daily',
  },
  {
    country: 'Hungary',
    region: 'Europe',
    flag: '🇭🇺',
    source1: 'Company Registration Court',
    source2: 'National Tax and Customs Administration (Nemzeti Adó- és Vámhivatal, NAV)',
    frequency: 'daily',
  },
  {
    country: 'Iceland',
    region: 'Europe',
    flag: '🇮🇸',
    source1: 'Register of Business Enterprises (Fyrirtækjaskrá)',
    source2: 'Directorate of Internal Revenue (Ríkisskattstjóri)',
    frequency: 'daily',
  },
  {
    country: 'India',
    region: 'Asia',
    flag: '🇮🇳',
    source1: 'Ministry of Corporate Affairs (MCA)',
    source2: 'Goods and Services Tax Network (GSTN)',
    frequency: 'daily',
  },
  {
    country: 'Indonesia',
    region: 'Asia',
    flag: '🇮🇩',
    source1: 'Ministry of Law and Human Rights',
    source2: 'Directorate General of Taxes (Direktorat Jenderal Pajak)',
    frequency: 'weekly',
  },
  {
    country: 'Iran',
    region: 'Middle East',
    flag: '🇮🇷',
    source1: 'Iran Company Registration Office',
    source2: 'Iranian National Tax Administration (INTA)',
    frequency: 'monthly',
  },
  {
    country: 'Iraq',
    region: 'Middle East',
    flag: '🇮🇶',
    source1: 'Companies Registration Directorate (Ministry of Trade)',
    source2: 'General Commission for Taxes (GCT)',
    frequency: 'monthly',
  },
  {
    country: 'Ireland',
    region: 'Europe',
    flag: '🇮🇪',
    source1: 'Companies Registration Office (CRO)',
    source2: 'Revenue Commissioners',
    frequency: 'daily',
  },
  {
    country: 'Italy',
    region: 'Europe',
    flag: '🇮🇹',
    source1: 'Business Register',
    source2: 'Agenzia delle Entrate (Italian Revenue Agency',
    frequency: 'daily',
  },
  {
    country: "Ivory Coast (CÔTE D'IVOIRE)",
    region: 'Africa',
    flag: '🇨🇮',
    source1: 'Trade and Personal Property Credit Register',
    source2: 'Direction Générale des Impôts (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Jamaica',
    region: 'Americas',
    flag: '🇯🇲',
    source1: 'Companies Office of Jamaica (COJ)',
    source2: 'Tax Administration Jamaica (TAJ)',
    frequency: 'monthly',
  },
  {
    country: 'Japan',
    region: 'Asia',
    flag: '🇯🇵',
    source1: 'Legal Affairs Bureau (Houmu Kyoku)',
    source2: 'National Tax Agency (NTA)',
    frequency: 'daily',
  },
  {
    country: 'Jordan',
    region: 'Middle East',
    flag: '🇯🇴',
    source1: 'Companies Control Department,',
    source2: 'Income and Sales Tax Department, Ministry of Finance',
    frequency: 'weekly',
  },
  {
    country: 'Kazakhstan',
    region: 'Asia',
    flag: '🇰🇿',
    source1: 'Ministry of Justice',
    source2: 'State Revenue Committee of the Ministry of Finance',
    frequency: 'weekly',
  },
  {
    country: 'Kenya',
    region: 'Africa',
    flag: '🇰🇪',
    source1: 'Business Registration Service (BRS)',
    source2: 'Kenya Revenue Authority (KRA)',
    frequency: 'weekly',
  },
  {
    country: 'Kosovo',
    region: 'Europe',
    flag: '🇽🇰',
    source1: 'Kosovo Business Registration Agency (KBRA)',
    source2: 'Tax Administration of Kosovo (TAK)',
    frequency: 'daily',
  },
  {
    country: 'Kuwait',
    region: 'Middle East',
    flag: '🇰🇼',
    source1: 'Ministry of Commerce and Industry',
    source2: 'Kuwait Tax Authority (KTA).',
    frequency: 'weekly',
  },
  {
    country: 'Kyrgyzstan',
    region: 'Asia',
    flag: '🇰🇬',
    source1: 'Ministry of Justice',
    source2: 'State Tax Service under the Government of the Kyrgyz Republic',
    frequency: 'monthly',
  },
  {
    country: 'Laos',
    region: 'Asia',
    flag: '🇱🇦',
    source1: 'Ministry of Industry and Commerce',
    source2: 'Tax Department, Ministry of Finance, Lao PDR',
    frequency: 'monthly',
  },
  {
    country: 'Latvia',
    region: 'Europe',
    flag: '🇱🇻',
    source1: 'Register of Enterprises of the Republic of Latvia',
    source2: 'State Revenue Service of Latvia (Valsts ieņēmumu dienests, VID)',
    frequency: 'daily',
  },
  {
    country: 'Leba-n',
    region: 'Middle East',
    flag: '🇱🇧',
    source1: 'Commercial Register (Registre du Commerce)',
    source2: 'Ministry of Finance – Directorate of VAT and Indirect Taxes',
    frequency: 'monthly',
  },
  {
    country: 'Lesotho',
    region: 'Africa',
    flag: '🇱🇸',
    source1: 'Lesotho National Business Registry (LNBR)',
    source2: 'Lesotho Revenue Authority (LRA)',
    frequency: 'monthly',
  },
  {
    country: 'Liberia',
    region: 'Africa',
    flag: '🇱🇷',
    source1: 'Liberia Business Registry',
    source2: 'Liberia Revenue Authority (LRA)',
    frequency: 'monthly',
  },
  {
    country: 'Libya',
    region: 'Africa',
    flag: '🇱🇾',
    source1: 'Commercial Registry',
    source2: 'General Tax Authority, Ministry of Finance, Libya',
    frequency: 'monthly',
  },
  {
    country: 'Liechtenstein',
    region: 'Europe',
    flag: '🇱🇮',
    source1: 'Office of Justice',
    source2: 'Tax Administration Liechtenstein (Steuerverwaltung Liechtenstein)',
    frequency: 'daily',
  },
  {
    country: 'Lithuania',
    region: 'Europe',
    flag: '🇱🇹',
    source1: 'Centre of Registers (Registrų Centras)',
    source2: 'State Tax Inspectorate (Valstybinė mokesčių inspekcija, VMI)',
    frequency: 'daily',
  },
  {
    country: 'Luxembourg',
    region: 'Europe',
    flag: '🇱🇺',
    source1: 'Luxembourg Business Register (Registre de Commerce et des Sociétés, RCS)',
    source2: "Administration de l'Enregistrement, des Domaines et de la TVA",
    frequency: 'daily',
  },
  {
    country: 'Macedonia',
    region: 'Europe',
    flag: '🇲🇰',
    source1: 'Central Registry of the Republic of North Macedonia',
    source2: 'Public Revenue Office (Управа за јавни приходи)',
    frequency: 'daily',
  },
  {
    country: 'Madagascar',
    region: 'Africa',
    flag: '🇲🇬',
    source1: 'Commercial and Personal Property Credit Register',
    source2: 'Direction Générale des Impôts (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Malawi',
    region: 'Africa',
    flag: '🇲🇼',
    source1: "Registrar General's Department",
    source2: 'Malawi Revenue Authority (MRA)',
    frequency: 'monthly',
  },
  {
    country: 'Malaysia',
    region: 'Asia',
    flag: '🇲🇾',
    source1: 'Companies Commission of Malaysia (Suruhanjaya Syarikat Malaysia, SSM)',
    source2: 'Royal Malaysian Customs Department (RMCD)',
    frequency: 'weekly',
  },
  {
    country: 'Mali',
    region: 'Africa',
    flag: '🇲🇱',
    source1: 'Trade and Personal Property Credit Register',
    source2: 'Direction Générale des Impôts (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Malta',
    region: 'Europe',
    flag: '🇲🇹',
    source1: 'Malta Business Registry',
    source2: 'Commissioner for Revenue',
    frequency: 'daily',
  },
  {
    country: 'Marshall Islands',
    region: 'Oceania',
    flag: '🇲🇭',
    source1: 'Registrar of Corporations',
    source2: 'Marshall Islands Revenue Authority (MIRA)',
    frequency: 'monthly',
  },
  {
    country: 'Martinique',
    region: 'Americas',
    flag: '🇲🇶',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'Mauritania',
    region: 'Africa',
    flag: '🇲🇷',
    source1: 'Trade and Personal Property Credit Register (Registre du Commerce et du Crédit Mobilier, RCCM)',
    source2: 'Direction Générale des Impôts et des Domaines',
    frequency: 'monthly',
  },
  {
    country: 'Mauritius',
    region: 'Africa',
    flag: '🇲🇺',
    source1: 'Registrar of Companies',
    source2: 'Mauritius Revenue Authority (MRA)',
    frequency: 'monthly',
  },
  {
    country: 'Mayotte',
    region: 'Africa',
    flag: '🇾🇹',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'Mexico',
    region: 'Americas',
    flag: '🇲🇽',
    source1: 'Public Registry of Commerce',
    source2: 'Servicio de Administración Tributaria (SAT) — Tax Administration Service',
    frequency: 'daily',
  },
  {
    country: 'Micronesia',
    region: 'Oceania',
    flag: '🇫🇲',
    source1: 'Department of Resources and Development (Business Registration Office)',
    source2: 'Federated States of Micronesia Department of Finance and Administration',
    frequency: 'monthly',
  },
  {
    country: 'Moldova',
    region: 'Europe',
    flag: '🇲🇩',
    source1: 'Public Services Agency (ASP)',
    source2: 'State Tax Service of the Republic of Moldova',
    frequency: 'daily',
  },
  {
    country: 'Montenegro',
    region: 'Europe',
    flag: '🇲🇪',
    source1: 'Central Registry of the Commercial Court',
    source2: 'Tax Administration of Montenegro',
    frequency: 'daily',
  },
  {
    country: 'Montserrat',
    region: 'Americas',
    flag: '🇲🇸',
    source1: 'Companies Registry',
    source2: 'Montserrat Inland Revenue Department',
    frequency: 'monthly',
  },
  {
    country: 'Morocco',
    region: 'Africa',
    flag: '🇲🇦',
    source1: 'Regional Commercial Registries',
    source2: 'Directorate General of Taxes (DGI)',
    frequency: 'weekly',
  },
  {
    country: 'Mozambique',
    region: 'Africa',
    flag: '🇲🇿',
    source1: 'Commercial Registry',
    source2: 'Tax Authority of Mozambique (Autoridade Tributária de Moçambique)',
    frequency: 'monthly',
  },
  {
    country: 'Myanmar',
    region: 'Asia',
    flag: '🇲🇲',
    source1: 'Directorate of Investment and Company Administration (DICA)',
    source2: 'Internal Revenue Department (IRD), Ministry of Planning and Finance',
    frequency: 'monthly',
  },
  {
    country: 'Namibia',
    region: 'Africa',
    flag: '🇳🇦',
    source1: 'Business and Intellectual Property Authority (BIPA)',
    source2: 'Namibia Revenue Agency (NamRA)',
    frequency: 'monthly',
  },
  {
    country: 'Nepal',
    region: 'Asia',
    flag: '🇳🇵',
    source1: 'Office of the Company Registrar',
    source2: 'Inland Revenue Department (IRD), Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'Netherlands',
    region: 'Europe',
    flag: '🇳🇱',
    source1: 'Netherlands Chamber of Commerce (Kamer van Koophandel, KvK)',
    source2: 'Dutch Tax and Customs Administration (Belastingdienst)',
    frequency: 'daily',
  },
  {
    country: 'New Caledonia',
    region: 'Oceania',
    flag: '🇳🇨',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'Direction des Services Fiscaux (DSF) — New Caledonia Tax Services',
    frequency: 'monthly',
  },
  {
    country: 'New Zealand',
    region: 'Oceania',
    flag: '🇳🇿',
    source1: 'New Zealand Companies Office',
    source2: 'Inland Revenue Department (IRD)',
    frequency: 'daily',
  },
  {
    country: 'Nicaragua',
    region: 'Americas',
    flag: '🇳🇮',
    source1: 'National Registry of Property and Commerce (Registro Nacional de la Propiedad y del Comercio)',
    source2: 'General Directorate of Taxes and Customs (Dirección General de Ingresos - DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Niger',
    region: 'Africa',
    flag: '🇳🇪',
    source1: 'RCCM',
    source2: 'Direction Générale des Impôts (DGI)',
    frequency: 'monthly',
  },
  {
    country: 'Nigeria',
    region: 'Africa',
    flag: '🇳🇬',
    source1: 'Corporate Affairs Commission (CAC)',
    source2: 'Federal Inland Revenue Service (FIRS)',
    frequency: 'weekly',
  },
  {
    country: 'Oman',
    region: 'Middle East',
    flag: '🇴🇲',
    source1: 'Ministry of Commerce, Industry and Investment Promotion',
    source2: 'Tax Authority(Zakat, Tax and Customs Authority)',
    frequency: 'weekly',
  },
  {
    country: 'Pakistan',
    region: 'Asia',
    flag: '🇵🇰',
    source1: 'Securities and Exchange Commission of Pakistan (SECP)',
    source2: 'Federal Board of Revenue (FBR',
    frequency: 'weekly',
  },
  {
    country: 'Palau',
    region: 'Oceania',
    flag: '🇵🇼',
    source1: 'Palau Ministry of Justice',
    source2: 'Ministry of Finance – Revenue Division',
    frequency: 'monthly',
  },
  {
    country: 'Palestine',
    region: 'Middle East',
    flag: '🇵🇸',
    source1: 'Ministry of National Economy',
    source2: 'Palestinian Ministry of Finance – Tax Department',
    frequency: 'monthly',
  },
  {
    country: 'Panama',
    region: 'Americas',
    flag: '🇵🇦',
    source1: 'Public Registry of Panama (Registro Público de Panamá)',
    source2: 'Dirección General de Ingresos (DGI)',
    frequency: 'weekly',
  },
  {
    country: 'Paraguay',
    region: 'Americas',
    flag: '🇵🇾',
    source1: 'Public Registry of Commerce (Registro Público de Comercio)',
    source2: 'Subsecretariat of State for Taxation (SET)',
    frequency: 'monthly',
  },
  {
    country: 'Peru',
    region: 'Americas',
    flag: '🇵🇪',
    source1: 'Public Registry (Registro Mercantil)',
    source2: 'National Superintendence of Tax Administration (SUNAT)',
    frequency: 'weekly',
  },
  {
    country: 'Poland',
    region: 'Europe',
    flag: '🇵🇱',
    source1: 'National Court Register (Krajowy Rejestr Sądowy, KRS)',
    source2: 'Ministry of Finance – National Revenue Administration (Krajowa Administracja Skarbowa, KAS',
    frequency: 'daily',
  },
  {
    country: 'Portugal',
    region: 'Europe',
    flag: '🇵🇹',
    source1: 'Institute of Registries and Notary (Instituto dos Registos e Notariado)',
    source2: 'Tax and Customs Authority (Autoridade Tributária e Aduaneira, AT)',
    frequency: 'daily',
  },
  {
    country: 'Puerto Rico',
    region: 'Americas',
    flag: '🇵🇷',
    source1: 'Puerto Rico Department of State',
    source2: 'Puerto Rico Department of Treasury (Departamento de Hacienda)',
    frequency: 'monthly',
  },
  {
    country: 'Qatar',
    region: 'Middle East',
    flag: '🇶🇦',
    source1: 'Ministry of Commerce and Industry',
    source2: 'General Tax Authority (GTA)',
    frequency: 'weekly',
  },
  {
    country: 'Reunion',
    region: 'Africa',
    flag: '🇷🇪',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'French Tax Administration (Direction générale des Finances publiques, DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'Romania',
    region: 'Europe',
    flag: '🇷🇴',
    source1: 'National Trade Register Office ( ONRC)',
    source2: 'National Agency for Fiscal Administration (Agenția Națională de Administrare Fiscală, ANAF)',
    frequency: 'daily',
  },
  {
    country: 'Russia',
    region: 'Asia',
    flag: '🇷🇺',
    source1: 'Federal Tax Service',
    source2: 'Federal Tax Service (Федеральная налоговая служба, FNS)',
    frequency: 'weekly',
  },
  {
    country: 'Rwanda',
    region: 'Africa',
    flag: '🇷🇼',
    source1: 'Rwanda Development Board',
    source2: 'Rwanda Revenue Authority (RRA)',
    frequency: 'monthly',
  },
  {
    country: 'St Barthélemy',
    region: 'Americas',
    flag: '🇧🇱',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'Tax Service of Saint Barthélemy',
    frequency: 'monthly',
  },
  {
    country: 'St Helena',
    region: 'Africa',
    flag: '🇸🇭',
    source1: 'St Helena Registry of Companies',
    source2: 't Helena Government – Income Tax Office',
    frequency: 'monthly',
  },
  {
    country: 'St Kitts and Nevis',
    region: 'Americas',
    flag: '🇰🇳',
    source1: "Companies Registry (Registrar General's Department)",
    source2: 'Inland Revenue Department, Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'St Lucia',
    region: 'Americas',
    flag: '🇱🇨',
    source1: 'Corporate Affairs and Intellectual Property Office (CAIPO)',
    source2: 'Inland Revenue Department, Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'St Martin (French)',
    region: 'Americas',
    flag: '🇲🇫',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'Direction Générale des Finances Publiques (DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'St Maarten (Dutch)',
    region: 'Americas',
    flag: '🇸🇽',
    source1: 'Chamber of Commerce and Industry of St Maarten',
    source2: 'Belastingdienst Caribisch Nederland',
    frequency: 'monthly',
  },
  {
    country: 'St Pierre & Miquelon',
    region: 'Americas',
    flag: '🇵🇲',
    source1: 'Registre du Commerce et des Sociétés (RCS)',
    source2: 'Direction Générale des Finances Publiques (DGFiP)',
    frequency: 'monthly',
  },
  {
    country: 'St Vincent & the Grenadines',
    region: 'Americas',
    flag: '🇻🇨',
    source1: "Companies Registry (Registrar General's Department)",
    source2: 'Inland Revenue Department, Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'Sao Tome & Principe',
    region: 'Africa',
    flag: '🇸🇹',
    source1: 'Commercial Registry',
    source2: 'Directorate of Taxes (Direção dos Impostos)',
    frequency: 'monthly',
  },
  {
    country: 'Saudi Arabia',
    region: 'Middle East',
    flag: '🇸🇦',
    source1: 'Ministry of Commerce',
    source2: 'Zakat, Tax and Customs Authority (ZATCA)',
    frequency: 'weekly',
  },
  {
    country: 'Senegal',
    region: 'Africa',
    flag: '🇸🇳',
    source1: 'rade and Personal Property Credit Register (Registre du Commerce et du Crédit Mobilier, RCCM)',
    source2: 'General Directorate of Taxes and Domains (Direction Générale des Impôts et des Domaines, DGID)',
    frequency: 'monthly',
  },
  {
    country: 'Serbia',
    region: 'Europe',
    flag: '🇷🇸',
    source1: 'Serbian Business Registers Agency (SBRA)',
    source2: 'Tax Administration of Serbia (Poreska uprava)',
    frequency: 'daily',
  },
  {
    country: 'Seychelles',
    region: 'Africa',
    flag: '🇸🇨',
    source1: 'Seychelles Registrar of Companies',
    source2: 'Seychelles Revenue Commission (SRC)',
    frequency: 'monthly',
  },
  {
    country: 'Sierra Leone',
    region: 'Africa',
    flag: '🇸🇱',
    source1: 'Corporate Affairs Commission',
    source2: 'National Revenue Authority (NRA)',
    frequency: 'monthly',
  },
  {
    country: 'Singapore',
    region: 'Asia',
    flag: '🇸🇬',
    source1: 'Accounting and Corporate Regulatory Authority (ACRA)',
    source2: 'Inland Revenue Authority of Singapore (IRAS)',
    frequency: 'daily',
  },
  {
    country: 'Slovakia',
    region: 'Europe',
    flag: '🇸🇰',
    source1: 'Business Register of the Slovak Republic',
    source2: 'Financial Administration of the Slovak Republic (Finančná správa)',
    frequency: 'daily',
  },
  {
    country: 'Slovenia',
    region: 'Europe',
    flag: '🇸🇮',
    source1: 'Slovenian Business Register (AJPES)',
    source2: 'Financial Administration of the Republic of Slovenia (Finančna uprava Republike Slovenije, FURS)',
    frequency: 'daily',
  },
  {
    country: 'Somalia',
    region: 'Africa',
    flag: '🇸🇴',
    source1: 'Ministry of Commerce and Industry (Business Registration Unit)',
    source2: 'Federal Inland Revenue Department (FIRD)',
    frequency: 'monthly',
  },
  {
    country: 'South Africa',
    region: 'Africa',
    flag: '🇿🇦',
    source1: 'Companies and Intellectual Property Commission (CIPC)',
    source2: 'South African Revenue Service (SARS)',
    frequency: 'weekly',
  },
  {
    country: 'South Korea',
    region: 'Asia',
    flag: '🇰🇷',
    source1: 'Supreme Court Registry (Company Registration Division)',
    source2: 'National Tax Service (NTS)',
    frequency: 'daily',
  },
  {
    country: 'South Sudan',
    region: 'Africa',
    flag: '🇸🇸',
    source1: 'Ministry of Justice (Business Registration Office)',
    source2: 'South Sudan Revenue Authority (SSRA)',
    frequency: 'monthly',
  },
  {
    country: 'Spain',
    region: 'Europe',
    flag: '🇪🇸',
    source1: 'Mercantile Registry (Registro Mercantil)',
    source2: 'State Tax Administration Agency (AEAT)',
    frequency: 'daily',
  },
  {
    country: 'Sri Lanka',
    region: 'Asia',
    flag: '🇱🇰',
    source1: 'Department of Registrar of Companies',
    source2: 'Department of Inland Revenue',
    frequency: 'weekly',
  },
  {
    country: 'Sudan',
    region: 'Africa',
    flag: '🇸🇩',
    source1: 'Ministry of Justice (Commercial Registration)',
    source2: 'Sudan Taxation Chamber, Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'Suriname',
    region: 'Americas',
    flag: '🇸🇷',
    source1: 'Chamber of Commerce and Industry of Suriname',
    source2: 'Suriname Tax Office (Belastingdienst Suriname)',
    frequency: 'monthly',
  },
  {
    country: 'Svalbard & Jan Mayen',
    region: 'Europe',
    flag: '🇸🇯',
    source1: 'Norwegian Register of Business Enterprises (Brønnøysund Register Centre)',
    source2: 'Norwegian Tax Administration (Skatteetaten)',
    frequency: 'daily',
  },
  {
    country: 'Swaziland',
    region: 'Africa',
    flag: '🇸🇿',
    source1: 'Eswatini Business Registry',
    source2: 'Eswatini Revenue Service (ERS)',
    frequency: 'monthly',
  },
  {
    country: 'Sweden',
    region: 'Europe',
    flag: '🇸🇪',
    source1: 'Swedish Companies Registration Office (Bolagsverket)',
    source2: 'Swedish Tax Agency (Skatteverket)',
    frequency: 'daily',
  },
  {
    country: 'Switzerland',
    region: 'Europe',
    flag: '🇨🇭',
    source1: 'Commercial Register (Handelsregisteramt)',
    source2: 'Federal Tax Administration (FTA)',
    frequency: 'daily',
  },
  {
    country: 'Syria',
    region: 'Middle East',
    flag: '🇸🇾',
    source1: 'Ministry of Economy and Foreign Trade',
    source2: 'Syrian Ministry of Finance – General Directorate of Taxes',
    frequency: 'monthly',
  },
  {
    country: 'Taiwan',
    region: 'Asia',
    flag: '🇹🇼',
    source1: 'Department of Commerce',
    source2: 'Ministry of Finance, National Taxation Bureau',
    frequency: 'daily',
  },
  {
    country: 'Tajikistan',
    region: 'Asia',
    flag: '🇹🇯',
    source1: 'State Register of Legal Entities',
    source2: 'Tax Committee under the Government of the Republic of Tajikistan',
    frequency: 'monthly',
  },
  {
    country: 'Tanzania',
    region: 'Africa',
    flag: '🇹🇿',
    source1: 'Business Registrations and Licensing Agency (BRELA)',
    source2: 'Tanzania Revenue Authority (TRA)',
    frequency: 'monthly',
  },
  {
    country: 'Thailand',
    region: 'Asia',
    flag: '🇹🇭',
    source1: 'Department of Business Development (DBD)',
    source2: 'Revenue Department, Ministry of Finance, Thailand',
    frequency: 'weekly',
  },
  {
    country: 'Togo',
    region: 'Africa',
    flag: '🇹🇬',
    source1: 'Trade and Personal Property Credit Register (Registre du Commerce et du Crédit Mobilier, RCCM)',
    source2: 'Direction Générale des Impôts et des Domaines (DGID)',
    frequency: 'monthly',
  },
  {
    country: 'Trinidad & Tobago',
    region: 'Americas',
    flag: '🇹🇹',
    source1: 'Companies Registry',
    source2: 'Inland Revenue Division (IRD), Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'Tunisia',
    region: 'Africa',
    flag: '🇹🇳',
    source1: 'Trade and Personal Property Credit Register (Registre du Commerce et du Crédit Mobilier, RCCM)',
    source2: 'Direction Générale des Impôts (DGI) — General Directorate of Taxes',
    frequency: 'monthly',
  },
  {
    country: 'Turkey',
    region: 'Asia',
    flag: '🇹🇷',
    source1: 'Central Registration System (MERSIS)',
    source2: 'Revenue Administration (Gelir İdaresi Başkanlığı)',
    frequency: 'weekly',
  },
  {
    country: 'Turkmenistan',
    region: 'Asia',
    flag: '🇹🇲',
    source1: 'Ministry of Justice',
    source2: 'State Tax Service of Turkmenistan',
    frequency: 'monthly',
  },
  {
    country: 'Turks & Caicos',
    region: 'Americas',
    flag: '🇹🇨',
    source1: 'Companies Registry',
    source2: 'Department of Inland Revenue, Ministry of Finance',
    frequency: 'monthly',
  },
  {
    country: 'Uganda',
    region: 'Africa',
    flag: '🇺🇬',
    source1: 'Uganda Registration Services Bureau (URSB)',
    source2: 'Uganda Revenue Authority (URA)',
    frequency: 'monthly',
  },
  {
    country: 'Ukraine',
    region: 'Europe',
    flag: '🇺🇦',
    source1: 'Unified State Register of Legal Entities',
    source2: 'State Tax Service of Ukraine',
    frequency: 'daily',
  },
  {
    country: 'United Arab Emirates',
    region: 'Middle East',
    flag: '🇦🇪',
    source1: 'Department of Economic Development (DED) in each Emirate',
    source2: 'Federal Tax Authority (FTA)',
    frequency: 'weekly',
  },
  {
    country: 'United Kingdom',
    region: 'Europe',
    flag: '🇬🇧',
    source1: 'Companies House',
    source2: 'HM Revenue & Customs (HMRC)',
    frequency: 'realtime',
  },
  {
    country: 'Uruguay',
    region: 'Americas',
    flag: '🇺🇾',
    source1: 'National Directorate of Commercial Registries',
    source2: 'Dirección General Impositiva (DGI) — General Tax Directorate',
    frequency: 'monthly',
  },
  {
    country: 'Uzbekistan',
    region: 'Asia',
    flag: '🇺🇿',
    source1: 'Ministry of Justice',
    source2: 'State Tax Committee of the Republic of Uzbekistan',
    frequency: 'monthly',
  },
  {
    country: 'Venezuela',
    region: 'Americas',
    flag: '🇻🇪',
    source1: 'National Commercial Registry',
    source2:
      'National Integrated Service of Customs and Tax Administration (Servicio Nacional Integrado de Administración Aduanera y Tributaria, SENIAT)',
    frequency: 'monthly',
  },
  {
    country: 'Vietnam',
    region: 'Asia',
    flag: '🇻🇳',
    source1: 'Business Registration Management Agency',
    source2: 'General Department of Taxation (GDT), Ministry of Finance',
    frequency: 'weekly',
  },
  {
    country: 'Virgin Islands',
    region: 'Americas',
    flag: '🇻🇮',
    source1: 'Virgin Islands Bureau of Commercial, Corporate & Intellectual Property Services',
    source2: 'Virgin Islands Inland Revenue Department',
    frequency: 'monthly',
  },
  {
    country: 'Virgin Islands British',
    region: 'Americas',
    flag: '🇻🇬',
    source1: 'Registrar of Companies',
    source2: 'Virgin Islands Inland Revenue Department',
    frequency: 'monthly',
  },
  {
    country: 'Western Sahara',
    region: 'Africa',
    flag: '🇪🇭',
    source1: 'Regional Commercial Registries',
    source2: "Morocco's Directorate General of Taxes (DGI)",
    frequency: 'monthly',
  },
  {
    country: 'Yemen',
    region: 'Middle East',
    flag: '🇾🇪',
    source1: 'Ministry of Industry and Trade',
    source2: 'Tax Authority, Ministry of Finance, Yemen',
    frequency: 'monthly',
  },
  {
    country: 'Zambia',
    region: 'Africa',
    flag: '🇿🇲',
    source1: 'Patents and Companies Registration Agency (PACRA)',
    source2: 'Zambia Revenue Authority (ZRA)',
    frequency: 'monthly',
  },
  {
    country: 'Zimbabwe',
    region: 'Africa',
    flag: '🇿🇼',
    source1: 'Registrar of Companies',
    source2: 'Zimbabwe Revenue Authority (ZIMRA)',
    frequency: 'monthly',
  },
  {
    country: 'Alabama',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Alabama Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Alaska',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Alaska Division of Corporations',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Arizona',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Arizona Corporation Commission',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Arkansas',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Arkansas Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'California',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'California Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Colorado',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Colorado Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Connecticut',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Connecticut Secretary of the State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Delaware',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Delaware Division of Corporations',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Florida',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Florida Department of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Georgia',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Georgia Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Hawaii',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Hawaii Department of Commerce and Consumer Affairs',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Idaho',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Idaho Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Illinois',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Illinois Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Indiana',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Indiana Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Iowa',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Iowa Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Kansas',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Kansas Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Kentucky',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Kentucky Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Louisiana',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Louisiana Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Maine',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Maine Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Maryland',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Maryland Department of Assessments and Taxation',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Massachusetts',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Massachusetts Secretary of the Commonwealth',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Michigan',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Michigan Department of Licensing and Regulatory Affairs',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Minnesota',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Minnesota Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Mississippi',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Mississippi Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Missouri',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Missouri Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Montana',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Montana Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Nebraska',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Nebraska Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Nevada',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Nevada Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'New Hampshire',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'New Hampshire Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'New Jersey',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'New Jersey Division of Revenue & Enterprise Services',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'New Mexico',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'New Mexico Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'New York',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'New York Department of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'North Carolina',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'North Carolina Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'North Dakota',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'North Dakota Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Ohio',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Ohio Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Oklahoma',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Oklahoma Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Oregon',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Oregon Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Pennsylvania',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Pennsylvania Department of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Rhode Island',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Rhode Island Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'South Carolina',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'South Carolina Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'South Dakota',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'South Dakota Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Tennessee',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Tennessee Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Texas',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Texas Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Utah',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Utah Division of Corporations and Commercial Code',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Vermont',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Vermont Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Virginia',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Virginia State Corporation Commission',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Washington',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Washington Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'West Virginia',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'West Virginia Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Wisconsin',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Wisconsin Department of Financial Institutions',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Wyoming',
    region: 'United States',
    flag: '🇺🇸',
    source1: 'Wyoming Secretary of State',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Alberta',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Alberta Corporate Registry',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'British Columbia',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'British Columbia Corporate Registry',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Manitoba',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Companies Office, Manitoba',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'New Brunswick',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Service New Brunswick',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Newfoundland and Labrador',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Service NL',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Nova Scotia',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Nova Scotia Registry of Joint Stock Companies',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Ontario',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Ontario Ministry of Government and Consumer Services',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Prince Edward Island',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'PEI Corporate and Business Names Registry',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Quebec',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Registraire des entreprises (Enterprise Registrar)',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Saskatchewan',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Information Services Corporation (ISC)',
    source2: null,
    frequency: 'daily',
  },
  {
    country: 'Northwest Territories',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Registry Services',
    source2: null,
    frequency: 'daily',
  },
  { country: 'Nunavut', region: 'Canada', flag: '🇨🇦', source1: 'Registry Services', source2: null, frequency: 'daily' },
  {
    country: 'Yukon',
    region: 'Canada',
    flag: '🇨🇦',
    source1: 'Yukon Corporate Affairs',
    source2: null,
    frequency: 'daily',
  },
];
